<template>
  <footer id="footer">
    <div class="container-fluid">
      <div class="text-center copyright">
        <img src="static/assets/images/logo_mkcl.png" alt="MKCL">
        <span>&copy; {{$t(footerBar.lblOrgnization)}}</span>
        <span>{{$t(footerBar.lblPowerdBy)}}</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'mfs-footer',
  data () {
    return {

    }
  }
}
</script>

<style lang="scss">
@import '../../../static/assets/styles/scss/variables.scss';

#footer {padding: 20px 0; border-top: 1px solid #ebebeb; font-size: 12px; line-height: 18px; color: #a7a7a7; background: #fff;
  img {margin-bottom: 10px; width: 80px;}
  span {display: block;}
}
</style>



// WEBPACK FOOTER //
// src/components/common/mfs-footer.vue